(() => {
  if (window.FFOverlayBlockInit) return;
  window.FFOverlayBlockInit = true;

  const blocks = [];

  function readInlinePixelVar(el, name) {
    return parseInt(el.style.getPropertyValue(name), 10) || 0;
  }

  function updateEntryMetrics(entry) {
    if (!entry.stage.isConnected || !entry.section.isConnected) return;

    entry.block.style.setProperty('--ff-overlay-block-height', `${entry.block.offsetHeight}px`);

    if (entry.mode === 'stick_bottom_on_view') {
      const viewportTop = Math.max(0, window.innerHeight - entry.bottomOffset - entry.block.offsetHeight);
      entry.block.style.setProperty('--ff-sticky-viewport-top', `${viewportTop}px`);
    }
  }

  function registerStage(stage) {
    const mode = stage.dataset.stickyMode || 'none';

    const section = stage.closest('.shopify-section');
    if (!section) return;

    const block = stage.querySelector('.ff-content-overlay-block');
    if (!block) return;

    // Establish a positioning context on the section.
    section.classList.add('ff-overlay-section');

    // Move the stage to be a child of the container element so that its
    // absolute `inset: 0` resolves against the container, independent of
    // any wrapper (`.content-over-media`, `.content`, ...) that the snippet
    // was originally rendered inside.
    const container = section.querySelector(':scope > .container');
    const target = container || section;

    if (stage.parentElement !== target) {
      target.appendChild(stage);
    }

    // Reveal the stage now that it is correctly placed.
    stage.classList.add('is-ff-mounted');
    stage.classList.add(`ff-sticky-mode--${mode}`);

    if (mode === 'none') return;

    const entry = {
      stage,
      block,
      section,
      mode,
      bottomOffset: readInlinePixelVar(stage, '--ff-sticky-bottom'),
    };

    blocks.push(entry);
    updateEntryMetrics(entry);
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-ff-overlay-block]:not([data-ff-init])').forEach((stage) => {
      stage.dataset.ffInit = 'true';
      registerStage(stage);
    });
  }

  function handleResize() {
    blocks.forEach((entry) => {
      entry.bottomOffset = readInlinePixelVar(entry.stage, '--ff-sticky-bottom');
      updateEntryMetrics(entry);
    });
  }

  window.addEventListener('resize', handleResize, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Re-init when Shopify's theme editor reloads a section.
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
